import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var BellRing = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M18 15.764V11c0-2.591-1.695-4.869-4.127-5.684A1.986 1.986 0 0 0 12 4c-.865 0-1.591.545-1.871 1.31C7.717 6.107 6 8.393 6 11v4.764l-.895 1.789A1 1 0 0 0 6 19h12.02a1 1 0 0 0 .795-1.607L18 15.764zM12 22a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2zM5.295 3.29C2 6.563 2 8.935 2 12h1l1-.063C4 9.009 4 7.396 6.705 4.71l-1.41-1.42zm12.001 1.42C20 7.396 20 9.009 20 12l2-.063c0-3.003 0-5.375-3.296-8.647l-1.408 1.42z", key: "k0" })));
});
BellRing.displayName = 'BellRing';
export var BellRingDimensions = { height: 24, width: 24 };
